export default "__VITE_ASSET__7HJzUtNE__"